module.exports = __webpack_public_path__ + "assets/img/14_1066.a9dd0796.jpg";